import React       from 'react';
import { connect } from 'react-redux';

import classNames from 'classnames';
import styles          from './Icons.css';
import { User }        from '../../models/User';
import { UserService } from '../../services/UserService';

type MembershipProps = {
    user: User;
    isStayingSharp?: boolean;
    size: string;
};

interface RootState {
    user: User
}

class MembershipIconComponent extends React.Component<MembershipProps> {

    addStyle(size: string) {
        switch (size) {
            case 'large':
                return styles.large;
            case 'small':
                return styles.small;
            case 'middle':
                return styles.middle;
            case 'coverLarge':
                return styles.coverLarge;
            default:
                return '';
        }
    }

    render() {
        const { user , isStayingSharp} = this.props;
        const styleLock = UserService.isValidMember(user) ? styles.unlockIcon : styles.lockIcon;
        return (
            <div className = {classNames(styles.membershipIcon, this.addStyle(this.props.size))}>
                <span className = {styles.membershipText}>
                    <i className = {classNames(styles.icon, styleLock)}/>Members Only {isStayingSharp && ' - Staying Sharp'} 
                </span>
            </div>
        );
    }
}

export const Membership = connect(
    (state: RootState, props) => ({
        user: state.user,
    }))(MembershipIconComponent);
